/* eslint-disable no-console */
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Popover } from "antd";
import ChevronIcon from "../../../../../Common/Svgs/ChevronIcon";
import TickIcon from "../../../../../Common/Svgs/TickIcon";
import useDebounce from "../../../../../Core/hooks/useDebounce";
import { updateUsers } from "../../../../../Redux/Slices/users.slice";
import { client } from "../../../../../Utils/axiosClient";

const TransferTripDropdown = ({ transferToDriver, setTransferToDriver }) => {
  const dispatch = useDispatch();

  const { currentDriver } = useSelector((state) => state.users);

  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);

  const debounceSearch = useDebounce(search);

  const getTransferDrivers = useCallback(async () => {
    try {
      dispatch(updateUsers({ key: "loading", value: true }));

      const filterObj = {
        driverId: Number(currentDriver?.id || 0),
        hubId: Number(currentDriver?.hubId || 0),
      };

      if (debounceSearch) filterObj.searchQuery = debounceSearch;

      const response = await client.get(
        `${process.env.REACT_APP_API_URL}/drivers/get-transfer-drivers`,
        { params: filterObj },
      );

      if (response.status === 200) {
        const localData = response?.data?.result || [];
        setData(localData);
      }
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(updateUsers({ key: "loading", value: false }));
    }
  }, [dispatch, currentDriver, debounceSearch]);

  useEffect(() => {
    getTransferDrivers();
  }, [getTransferDrivers]);

  return (
    <div>
      <p className="font-aileron text-xs font-normal text-dark-gray capitalize mb-1.5">
        Driver
      </p>

      <Popover
        zIndex={3001}
        trigger="click"
        placement="bottomLeft"
        open={open}
        arrow={false}
        onOpenChange={(state) => setOpen(state)}
        content={
          <div className="w-[488px] bg-background-white rounded-md p-2 max-h-[200px] flex flex-col">
            <input
              className="px-3 py-2 w-full h-10 bg-background hover:bg-background focus:bg-background focus:border focus:border-primary outline-none font-aileron text-xs font-medium leading-4.5 text-dark-gray rounded-md placeholder:font-aileron placeholder:text-dark-gray"
              placeholder="Select New Driver"
              onChange={(e) => setSearch(e.target.value)}
            />

            <div className="mt-1 flex-1 overflow-y-auto">
              {data?.length ? (
                data?.map((d) => {
                  const selected = transferToDriver.id === d.id;

                  return (
                    <button
                      type="button"
                      key={d.id}
                      className="w-full flex items-center justify-between py-2 px-1 capitalize group hover:bg-background"
                      onClick={() => {
                        setTransferToDriver(d);
                        setOpen(false);
                      }}
                    >
                      <p
                        className={`font-aileron text-xs font-semibold text-left capitalize
                            ${
                              selected
                                ? "text-black"
                                : "text-dark-gray group-hover:text-black"
                            }
                   `}
                      >
                        {d?.firstName?.trim()} {d?.lastName?.trim()}
                      </p>

                      {selected ? (
                        <TickIcon size={16} className="text-primary" />
                      ) : null}
                    </button>
                  );
                })
              ) : (
                <p className="font-aileron py-3 px-1 text-xs font-semibold text-left">
                  No data found
                </p>
              )}
            </div>
          </div>
        }
      >
        <div
          role="button"
          className="px-3.5 py-2 w-[488px] bg-white flex items-center justify-between border rounded-md"
        >
          <p
            className={`font-aileron font-semibold text-xs capitalize ${
              transferToDriver?.id !== 0 ? "text-black" : "text-dark-gray"
            }`}
          >
            {transferToDriver?.id !== 0
              ? `${transferToDriver?.firstName?.trim()} ${transferToDriver?.lastName?.trim()}`
              : "Select New Driver"}
          </p>

          <ChevronIcon
            strokeWidth="1"
            className={`w-5 h-5 stroke-dark-gray transform transition-all duration-[400] ${
              open ? "-rotate-90" : "rotate-90"
            }`}
          />
        </div>
      </Popover>
    </div>
  );
};

export default TransferTripDropdown;
